export const onMouseDownSelectableHack = (e) => {
    if (e.target.classList.contains('ant-select-selection-item')) {
        const el = e.target;
        el.setAttribute('style', 'user-select: text;');

        if (el.parentNode.querySelector('.ant-select-selection-search-input').disabled) {
            e.stopPropagation();
        }
    }
};